import { createAction } from '@reduxjs/toolkit';

import type { AppState, Meta } from '~/renderer/store/types';

type Payload = Partial<AppState> | undefined;

type HydratePayload = {
  payload: Payload;
} & {
  meta: Meta;
};

function withPayloadType<T extends HydratePayload>() {
  return (action: T) => ({
    payload: action.payload,
    meta: action?.meta,
  });
}

const hydrateStore = createAction('HYDRATE', withPayloadType());

export { hydrateStore };
